// extracted by mini-css-extract-plugin
export default {"emojis":"emojis__UvwKt","feedbackItem":"feedbackItem__r9hjZ","emoji":"emoji__OeUUk","imgtext":"imgtext__sk6GR"};